import { HttpClient, serializeJSONApiData } from '@opallabs/api'
import loadWorkflow from '../loadWorkflow'

const patchWorkflowPhase = ({
  type,
  identifier,
  workflowId,
  phaseId,
  params,
}) =>
  HttpClient().patch(
    `/api/v1/${
      type && identifier ? `${type}/${identifier}/` : ''
    }workflow/${workflowId}/phases/${phaseId}`,
    { data: params.data }
  )

const updateWorkflowPhase =
  ({
    identifier,
    onUpdatePhase,
    phaseId,
    type = 'content',
    update,
    workflowId,
  }) =>
  (dispatch) => {
    const params = serializeJSONApiData('approval-phases', {
      ...update,
      id: phaseId,
    })

    return patchWorkflowPhase({
      type,
      identifier,
      workflowId,
      phaseId,
      params,
    })
      .then((response) => {
        if (onUpdatePhase) {
          onUpdatePhase()
        }
        return dispatch(loadWorkflow(response.data))
      })
      .catch((err) => {
        console.log(err)
        throw err
      })
  }

export default updateWorkflowPhase
